import React,{ useState, useEffect } from 'react';
import {
    Button
} from 'antd';

import {
    PhoneOutlined,
    MessageOutlined,
    RightOutlined
} from '@ant-design/icons';

function CareMenu() {
    return (
        <div className='default-menu-items support-menu-items'>
            <div className='support-team-cta-container support-state'>
                <h4>Questions about Care or Billing?</h4>
                <p>Our caring team is here to address any billing inquiries, help you understand your charges, and assist with payment arrangements.</p>
                <div className='support-cta-button-container'>
                <Button
                        icon={ <PhoneOutlined /> }
                        type="primary"
                        href={ "tel:1-866-434-5888" }
                        style={ { 'marginRight' : '1rem' } }
                    > Call 1-866-434-5888</Button>
                    <Button 
                        className="live-chat-link"
                        icon={ <MessageOutlined /> }
                    >Start a Live Chat</Button>
                </div>
                <span style={{ fontSize:'0.8rem' }}>Available between the hours of 8:00am - 9:00pm ET</span>
            </div>
        </div>
    )
}

export default CareMenu